export default "__VITE_ASSET__BN$08VsA__"